import { ReactNode } from 'react';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hasProductAccess } from '../../services/entitlement';
import { signOut } from '../../services/authService';
import { APP_LOGO_SRC } from '../../lib/branding';
import { LanguageSelector } from '../common/LanguageSelector';
import { useEntitlement } from './LicensingProvider';

export function BillingRecoveryRoute({ children }: { children: ReactNode }) {
  const { t } = useTranslation('licensing');
  const { entitlementState } = useEntitlement();

  if (hasProductAccess(entitlementState)) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-[var(--app-canvas)]">
      <header className="border-b border-gray-200 bg-[#FBE99F]/85 px-4 py-3 backdrop-blur sm:px-6">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4">
          <img src={APP_LOGO_SRC} alt="Honey" className="h-10 w-auto" />
          <div className="flex items-center gap-2 sm:gap-3">
            <LanguageSelector variant="compact" />
            <button
              type="button"
              onClick={() => void signOut()}
              className="inline-flex min-h-10 items-center gap-2 rounded-control px-3 py-2 text-sm font-semibold text-[#2F2F2F] transition-colors hover:bg-white/50 focus:outline-none focus:ring-2 focus:ring-[#C79A00] focus:ring-offset-2"
            >
              <ArrowRightOnRectangleIcon className="h-4 w-4" aria-hidden="true" />
              <span className="hidden sm:inline">{t('actions.sign_out')}</span>
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto h-[calc(100vh-4.25rem)] w-full max-w-6xl px-4 py-6 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
